__turbopack_context__.v({
  "arrow": "EJv4-W_arrow",
  "errorTemplate": "EJv4-W_errorTemplate",
  "icon": "EJv4-W_icon",
  "link": "EJv4-W_link",
  "linkItem": "EJv4-W_linkItem",
  "linkList": "EJv4-W_linkList",
  "logo": "EJv4-W_logo",
  "logoutButton": "EJv4-W_logoutButton",
  "message": "EJv4-W_message",
  "title": "EJv4-W_title",
});
